// Mock data for JTS Alsace - Pest Control Website

export const mockData = {
  company: {
    name: "Jts Alsace",
    tagline: "Traiteur de Nuisible",
    availability: "24h/24 - 7j/7",
    certification: "Certifié Biocide",
    description: "Expert en traitement des nuisibles en Alsace. Intervention rapide et efficace pour tous types de nuisibles."
  },
  
  contact: {
    address: "3 Rue Claude Ignace Calinnet",
    city: "68287 Rouffach",
    phone: "06 51 10 27 07",
    email: "domjawo68@gmail.com",
    fullAddress: "3 Rue Claude Ignace Calinnet, 68287 Rouffach"
  },
  
  services: [
    {
      id: 1,
      name: "Cafards / Blattes",
      icon: "bug",
      image: "https://images.unsplash.com/photo-1611773236409-f3ee161007a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjb2Nrcm9hY2h8ZW58MHx8fHwxNzc1OTQ2NTE5fDA&ixlib=rb-4.1.0&q=85",
      description: "Élimination complète et durable des cafards et blattes. Intervention rapide avec traitement professionnel adapté.",
      features: ["Diagnostic précis", "Traitement ciblé", "Garantie résultat"]
    },
    {
      id: 2,
      name: "Punaises de Lit",
      icon: "bed",
      image: "https://images.unsplash.com/photo-1730568467302-82f8691db691?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxiZWQlMjBidWd8ZW58MHx8fHwxNzc1OTQ2NTIzfDA&ixlib=rb-4.1.0&q=85",
      description: "Traitement efficace contre les punaises de lit. Solution rapide pour retrouver des nuits paisibles.",
      features: ["Détection thermique", "Traitement complet", "Suivi post-intervention"]
    },
    {
      id: 3,
      name: "Rats",
      icon: "rat",
      image: "https://images.unsplash.com/photo-1718345641213-80cfe1424084?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxyYXR8ZW58MHx8fHwxNzc1OTQ2NTI3fDA&ixlib=rb-4.1.0&q=85",
      description: "Dératisation professionnelle et sécurisée. Intervention discrète et efficace pour votre tranquillité.",
      features: ["Analyse des passages", "Pose de pièges sécurisés", "Prévention récidive"]
    },
    {
      id: 4,
      name: "Guêpes",
      icon: "bee",
      image: "https://images.unsplash.com/photo-1584709261141-f32daef6aa9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXNwfGVufDB8fHx8MTc3NTk0NjUzMXww&ixlib=rb-4.1.0&q=85",
      description: "Destruction de nids de guêpes en toute sécurité. Équipement professionnel pour une intervention sans risque.",
      features: ["Intervention sécurisée", "Destruction totale du nid", "Disponible en urgence"]
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Marie D.",
      location: "Colmar",
      rating: 5,
      text: "Intervention très rapide pour un problème de punaises de lit. Professionnel et efficace !",
      date: "Avril 2026"
    },
    {
      id: 2,
      name: "Jean-Pierre L.",
      location: "Mulhouse",
      rating: 5,
      text: "Excellent service pour la dératisation. Très satisfait du résultat.",
      date: "Mars 2026"
    },
    {
      id: 3,
      name: "Sophie M.",
      location: "Rouffach",
      rating: 5,
      text: "Disponible 24/7 comme promis ! Merci pour votre réactivité.",
      date: "Février 2026"
    }
  ],
  
  faqs: [
    {
      id: 1,
      question: "Intervenez-vous vraiment 24h/24 ?",
      answer: "Oui, nous sommes disponibles 24 heures sur 24, 7 jours sur 7 pour répondre à vos urgences."
    },
    {
      id: 2,
      question: "Quelle est votre zone d'intervention ?",
      answer: "Nous intervenons dans toute l'Alsace, avec une base à Rouffach pour une réactivité optimale."
    },
    {
      id: 3,
      question: "Les traitements sont-ils dangereux ?",
      answer: "Nous utilisons des produits certifiés biocides, sûrs pour vous et votre famille lorsqu'ils sont appliqués par nos professionnels."
    },
    {
      id: 4,
      question: "Quel est le délai d'intervention ?",
      answer: "Nous nous engageons à intervenir dans les plus brefs délais, généralement sous 24h, et en urgence si nécessaire."
    }
  ],
  
  images: {
    hero: "https://images.unsplash.com/photo-1747659629851-a92bd71149f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwZXN0JTIwY29udHJvbCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzU5NDY1MTV8MA&ixlib=rb-4.1.0&q=85",
    technician: "https://images.unsplash.com/photo-1612947890379-5146d3b4de07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxwZXN0JTIwY29udHJvbCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzU5NDY1MTV8MA&ixlib=rb-4.1.0&q=85"
  }
};
